import { FC, useState } from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { Button, Icon, useToast } from '@eluve/components';

interface DiffExportButtonProps {
  appointmentId: string;
  tenantId: string;
  type: 'summary' | 'ehr';
}

export const DiffExportButton: FC<DiffExportButtonProps> = ({
  appointmentId,
  tenantId,
  type,
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const client = useApiClient();
  const toast = useToast();

  const handleExportDiff = async () => {
    try {
      setIsExporting(true);

      const response = await client.reviewer.exportDiff({
        params: { tenantId, appointmentId },
        body: { type },
      });

      if (response.status !== 200) {
        throw new Error('Export failed');
      }

      const { downloadUrl } = response.body;

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute(
        'download',
        `appointment-${type}-diff-${appointmentId}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      toast.error('Failed to export diff data');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button variant="outline" loading={isExporting} onClick={handleExportDiff}>
      <Icon name="ArrowDownToLine" size="auto" />
      Download Diff
    </Button>
  );
};
